<template>
  <!-- 用户管理-活动币使用日志 -->
  <div class="activity_mall_log-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item style="margin-left: 20px"> </el-form-item>
        <el-form-item>
          <el-upload
            accept=".xls,.xlsx"
            :show-file-list="false"
            :on-success="onSuccess"
            :on-error="onError"
            style="display: inline-flex; margin-right: 10px"
            :action="action"
            :headers="headers"
          >
            <el-button size="mini" type="primary" icon="el-icon-upload2">
              上传表(.xls/.xlsx)
            </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-download"
            @click="downloadExcel"
          >
            下载模版
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="query.user_id"
            placeholder="请输入用户uid"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="getData(1)">
            搜索
          </el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="user_id" label="用户UID" align="center">
        </el-table-column>
        <el-table-column prop="change_money" label="变动金额" align="center">
        </el-table-column>
        <el-table-column prop="before_money" label="变动前金额" align="center">
        </el-table-column>
        <el-table-column prop="after_money" label="变动后金额" align="center">
        </el-table-column>
        <el-table-column prop="type" label="变动说明" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.type == 1">后台赠送</span>
            <span v-if="row.type == 2">用户使用</span>
            <span v-if="row.type == 3">出售</span>
            <span v-if="row.type == 4">扣手续费回滚</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="赠送时间" align="center">
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center">
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { api, server, delData, getData, patchData, postData, getApiData, patchApiData, postApiData } from '@/http'
import { getCookie } from '@/utils/cookie'
export default {
  data() {
    return {
      loading: false,
      query: {
        page: 1,
        user_id: undefined
      },
      dataList: undefined,
      dataMeta: undefined
    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${api}shop_coins`
    }
  },
  watch:{
    //监听路由
    $route: {
      handler(val, oldval) {
        if (val.name === "activity_mall_log") {
          if(val.params && val.params.user_id){
            this.query.user_id=val.params.user_id
            this.getData(1)
          }
        }
      },
      deep: true,// 深度观察监听
      immediate: true, //首次监听
    },
  },
  created() {
    this.getData(1)
  },
  methods: {
    getData(num) {
      //获取数据
      if (num === 1) {
        this.query.page = 1
      }
      let params = this.query
      this.loading = true
      getApiData(`shop_coins_used_record`, params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res
        }).finally(() => {
          this.loading = false
        })
    },
    onSuccess(res) {
      //上传文件成功
      this.$message.success("上传成功！");
    },
    onError(err) {
      this.$message.error("上传失败！");
    },
    downloadExcel() {
      //下载excel模版
      window.open('./excel/活动币发放模版.xlsx', '_blank')
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }
}
</script>
<style lang="less" scoped>
</style>